import { Component, OnInit, NgModule, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { Observable ,  EMPTY as empty } from 'rxjs';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import {
  User,
  AppRole,
  Location,
  UserRegistrationModel,
  HqLocationsModel,
  PostLocationsModel
} from '../models/user.model';
import { ReportCategory, ReportMetadata, ReportYear, ReportSchedule, UserReportCategory, FrequencyType } from '../models/report.model';
import { ReportdashboardService } from '../services/reportdashboard.service';
import { ReportScheduleService } from '../services/reportschedule.service';
//import { forEach, and } from '@angular/router/src/utils/collection';
import { SelectItem } from 'primeng/api';
import { stringify } from 'querystring';
import { NotifierService } from 'angular-notifier';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reportschedule',
  templateUrl: './reportschedule.component.html',
  styleUrls: ['./reportschedule.component.css']
})
export class ReportscheduleComponent implements OnInit {
  countries: Location[];
  post: Location[];
  programArea: Location;
  reportCategory: Location[];
  replicateReportScheduleData: ReportMetadata[];
  reportMetadata: ReportMetadata;
  reportCategoriesdata: ReportCategory[];
  reportYear: ReportYear[];
  region: PostLocationsModel[];
  addNewReportDialog: boolean = false;
  currentUser: User;
  reportScheduleData: ReportMetadata[];
  recallReportScheduleData: ReportSchedule[];
  selectedYear: ReportYear;
  frequencyTypes :FrequencyType[];
  reportNameData: any[];
  editReportsfields: ReportSchedule[] = [];
  replicateReportsfields: ReportSchedule[] = [];
  addNewReportfields: ReportSchedule[] = [];
  enableSave: boolean = false;
  isReportScheduleEditable: boolean;
  reportDistribution: SelectItem[] = [];
  selectedReportDistribution: boolean;
  addNewReportSchedule: ReportMetadata[] = [];
  previewReportScheduleDialog: boolean = false;
  releaseReportSchedule: ReportMetadata[];
  filterRreportCategory: SelectItem[];
  filterReportName: SelectItem[];
  filterFasPost: SelectItem[];
  filtercountry: SelectItem[];
  filterProgramArea: SelectItem[];
  filterDueDate: SelectItem[];
  filterProposedDue: SelectItem[];
  filterDistributionTypes: SelectItem[];
  filterFrequencyTypes: SelectItem[];
  addButton: boolean = false;
  previewButton: boolean = false;
  currentYear: number;
  selectedCategory: boolean = false;
  selectedCountry: boolean = false;
  selectedPost: boolean = false;
  selectedFrequencyType: boolean = false;
  selectedDistribution: boolean = false;
  selectedDueDate: boolean = false;
  recordCount: number;
  newRecordCount: number;
  reportScheduleforStatus: ReportSchedule;
  programAreaByCategory: string;

  @Input()
  locations: HqLocationsModel[];
  constructor(
    private reportDashboardService: ReportdashboardService,
    private authUserService: AuthUserService,
    private reportService: ReportdashboardService,
    private lookupService: LookupService,
    private authUser: AuthUserService,
    private reportSchedule: ReportScheduleService,
    private notifier: NotifierService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.lookupService.getReportYear().subscribe((data: ReportYear[]) => {
      this.reportYear = data.sort();
      for (let cnt = data.length - 1; cnt >= 0; cnt--) {
        if (this.reportYear[cnt].year != this.currentYear && this.reportYear[cnt].year != this.currentYear + 1) {
          this.reportYear.splice(cnt, 1);
        }
      }
    });

    this.currentUser = this.authUser._user;

    this.reportNameData = [
      { id: 1, reportName: 'Monthly' },
      { id: 2, reportName: 'Quarterly' },
      { id: 3, reportName: 'Semi-Annual' },
      { id: 4, reportName: 'Annual' },
      { id: 5, reportName: 'Weekly' },
      { id: 6, reportName: 'Annual Addendum' }
    ];

    this.reportDistribution.push({ label: 'Public', value: 'Public' });
    this.reportDistribution.push({ label: 'Internal', value: 'Internal' });

    this.lookupService.getAllReportCategories$().subscribe((reportData: ReportCategory[]) => {
      // this.lookupService.getUserAllReportCategories().subscribe((reportData: ReportCategory[]) => {
      this.reportCategoriesdata = reportData.sort(
        (a, b): number => {
          if (a.categoryName < b.categoryName) return -1;
          if (a.categoryName > b.categoryName) return 1;
          return 0;
        }
      );
    });

    this.lookupService.getParentLocation(this.authUserService._user.userLocations[0].locationId).subscribe((data: Location) => {
        this.programArea = data;
      });

    this.lookupService.getRootLocations('PostUser').subscribe((data: Location[]) => {
      this.countries = data.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
  }

  onChangeCountry(country, reportSchedule: ReportMetadata) {
  // console.log('Country Name' + country.id);
    this.selectedCountry = true;
    reportSchedule.countryId = country.id;
    this.lookupService.getChildLocations(country.id).subscribe((data: Location[]) => {
      reportSchedule.posts = data.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
  }

  onChangeFasPost(fasPost, reportSchedule) {
  // console.log('POst Name' + fasPost.id);
  this.selectedPost = true;
    reportSchedule.fasPostId = fasPost.id;
  }

  onReportYearChange(reportYear) {
    var yr = new Date().getFullYear();
    this.addButton = true;
    this.previewButton = false;
    if (reportYear.year == yr) {
      this.enableSave = false;
      // console.log('Enable Save-------' + this.enableSave);
    } else if (reportYear.year == yr + 1) {
      this.enableSave = true;
    }
    this.mapReportSchedule(reportYear.year);
    this.isReportScheduleEditable = true;
    this.selectedYear = reportYear;
  }

  replicateReportSchedule() {
    return new Promise<void>((resolve, reject) => {
      // this.reportSchedule.getReportSchedulesByYear(this.selectedYear.year - 1).subscribe(
      this.reportSchedule.replicateReportScheduleForYear(this.selectedYear.year).subscribe(
      (data: any) => {
          this.recordCount = data;
// console.log("Count -----  :  " + this.recordCount);
          if (this.recordCount > 0) {
            // this.replicateReports();
            this.mapReportSchedule(this.selectedYear.year);
            this.notifier.notify('success', 'Schedules replicated successfully');
          }
          if (this.recordCount == 0)
             this.notifier.notify('success', 'No new Schedules to replicate');
           else  if (this.recordCount == -1)
             this.notifier.notify('error', ' Something went wrong, please contact administrator');
        }

        ,
        error => console.log(error)
      );
      resolve();
    });
  }

  mapReportSchedule(reportingYear: number) {
    this.reportSchedule.getReportSchedulesByYear(reportingYear).subscribe((data: ReportMetadata[]) => {
      this.reportScheduleData = data.sort(
        (a, b): number => {
          if (a.categoryName < b.categoryName) return -1;
          if (a.categoryName > b.categoryName) return 1;
          return 0;
        });
         //console.log("FIRST Records" + JSON.stringify(this.reportScheduleData[0]));
      var reportCategory = new Array<string>();
      var reportNameType = new Array<string>();
      // var region = new Array<string>();
      var programAreaType = new Array<string>();
      var postType = new Array<string>();
      var countryType = new Array<string>();
      var distributionType = new Array<string>();
      var frequencyTypes = new Array<string>();
      var dueDate = new Array<Date>();
      var proposedDueDate = new Array<Date>();

      for (let i = 0; i < this.reportScheduleData.length; i++) {
        reportCategory.push(this.reportScheduleData[i].categoryName);
        reportNameType.push(this.reportScheduleData[i].reportName);
        // region.push(this.reportScheduleData[i].region);
        programAreaType.push(this.reportScheduleData[i].ProgramAreaName);
        countryType.push(this.reportScheduleData[i].parentPostLocation);
        postType.push(this.reportScheduleData[i].postLocation);
        distributionType.push(this.reportScheduleData[i].distribution); //isPublic === true ? "Public" : "Internal");
        dueDate.push(this.reportScheduleData[i].reportDueDate);
        if (this.reportScheduleData[i].proposedDueDate != null) {
          proposedDueDate.push(this.reportScheduleData[i].proposedDueDate);
        }
        frequencyTypes.push(this.reportScheduleData[i].frequencyTypeName);
        if (!this.reportScheduleData[i].isReleased) {
          this.previewButton = true;
        }
      }

      this.selectOrUnselectAll(true);
      this.filterRreportCategory = this.getUniqueValues(reportCategory);
      this.filterReportName = this.getUniqueValues(reportNameType);
      // this.filterProgramArea = this.getUniqueValues(region);
      this.filterProgramArea = this.getUniqueValues(programAreaType);
      this.filtercountry = this.getUniqueValues(countryType);
      this.filterFasPost = this.getUniqueValues(postType);
      this.filterDistributionTypes = this.getUniqueValues(distributionType);
      this.filterFrequencyTypes = this.getUniqueValues(frequencyTypes);
      this.filterDueDate = this.dateSort(dueDate);
      this.filterProposedDue = this.dateSort(proposedDueDate);
    });
  }

  onCategoryChange(reportCategoriesdata, rowIndex) {
    this.addNewReportSchedule[rowIndex].categoryName = reportCategoriesdata.categoryName;
    this.addNewReportSchedule[rowIndex].categoryId = reportCategoriesdata.id;
    this.selectedCategory = true;
    this.lookupService.getReportCategoryById(reportCategoriesdata.id).subscribe((reportCategorydata:ReportCategory)=>{
        this.lookupService.getLocation(reportCategorydata.programAreaId).subscribe((programAreadata:Location)=>{
        this.addNewReportSchedule[rowIndex].ProgramAreaId = programAreadata.id;
        this.addNewReportSchedule[rowIndex].ProgramAreaName = programAreadata.locationName;
        });
    });
  }

  getUniqueValues(filterItem: any[]): SelectItem[] {
    var returnArray = new Array<SelectItem>();
    for (let i = 0; i < filterItem.length; i++) {
      if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
        returnArray.push({ label: filterItem[i], value: filterItem[i] });
    }
    returnArray.sort((a,b):number=>{
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
    return returnArray;
  }

  dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

  selectOrUnselectAll(isSelected: boolean) {
    //this.enableSave = isSelected;
    for (const report of this.reportScheduleData) {
      report.selected = isSelected;
    }
  }

  onFrequencyTypeChange(selectedFrequencyType, rowIndex) {
    this.addNewReportSchedule[rowIndex].frequencyTypeName = selectedFrequencyType.frequencyTypeName;
    this.addNewReportSchedule[rowIndex].frequencyTypeId = selectedFrequencyType.id;
    this.selectedFrequencyType = true;
  }

  onReportDistributionChange(reportDistribution, rowIndex) {
    // console.log("Distribution" + this.selectedReportDistribution)
    this.selectedDistribution = true;
    this.addNewReportSchedule[rowIndex].distribution = reportDistribution;
  }

  onReportDueDate()
  {
    // console.log("DueDate" + this.selectedDueDate)
    this.selectedDueDate = true;
  }

  onSaveReportSchedule(reportscheduleIndex:number,reportId:any,isPublic:string,reportDueDate:Date,proposedDueDate:Date)
  {
    //console.log("Distribution & DUe Date " + isPublic === 'Public' ? true : false + ' and ' + this.datePipe.transform(reportDueDate, 'MM/dd/yyyy'));
     this.reportService.getReportScheduleById(reportId).subscribe((metadata:ReportSchedule)=>{
        this.reportScheduleforStatus = metadata;

        if (this.reportScheduleforStatus.reportNumber == null)
        {

            this.reportSchedule.updateReportScheduleById(reportId,
                                                    isPublic === 'Public' ? true : false,
                                                    this.datePipe.transform(reportDueDate, 'MM/dd/yyyy'),
                                                    this.datePipe.transform(proposedDueDate, 'MM/dd/yyyy')).subscribe(resp => {
                  if (resp.ok) {
                    this.notifier.notify('success', 'Schedule updated successfully');
                  }
                });
        }
          else
        {
          this.notifier.notify('error', 'Cannot update the report schedule as it is NOT under NOT Started state.');
        }
    });
  }

  onChangeSelection(reportscheduleIndex, isReportScheduleEditable) {

    this.reportService.getReportScheduleById(this.reportScheduleData[reportscheduleIndex].id).subscribe((metadata:ReportSchedule)=>{
        this.reportScheduleforStatus = metadata;

        if (this.reportScheduleforStatus.reportNumber == null)
        {
            //console.log("Released Record delete=============" + JSON.stringify(metadata));

            this.reportScheduleData[reportscheduleIndex].selected = isReportScheduleEditable;
            this.reportSchedule.deleteReportSchedule(this.reportScheduleData[reportscheduleIndex].id).subscribe(resp => {
              if (resp.ok) {
                this.notifier.notify('success', 'Schedule deleted successfully');
                this.reportScheduleData.splice(reportscheduleIndex, 1);
              }
            },error=>{
              this.notifier.notify('error', 'Failed to Delete Report Schedule');
            });
        }
        else
        {
          this.notifier.notify('error', 'Cannot delete the report scheduke as it is NOT under NOT Started state.');
        }
    });

  }

  // onRecallSelection(reportscheduleIndex) {
  //   this.recallReportScheduleData = [];
  //   this.reportScheduleData[reportscheduleIndex];

  //   // this.recallReportScheduleData.push({
  //   //   Id: this.reportScheduleData[reportscheduleIndex].id,
  //   //   ProgramAreaId: this.reportSchedule[reportscheduleIndex].ProgramAreaId,
  //   //   ReportYear: this.reportSchedule[reportscheduleIndex].selectedYear.year,
  //   //   ReportYearId: this.reportSchedule[reportscheduleIndex].selectedYear.id,
  //   //   CategoryId: this.reportSchedule[reportscheduleIndex].categoryId,
  //   //   ReportName: this.reportSchedule[reportscheduleIndex].reportName,
  //   //   IsRequired: this.reportSchedule[reportscheduleIndex].IsRequired,
  //   //   IsPublic: this.reportSchedule[reportscheduleIndex].isPublic, // === 'Public' ? true : false,
  //   //   PostLocationId: this.reportSchedule[reportscheduleIndex].fasPostId,
  //   //   ParentLocationId: this.reportSchedule[reportscheduleIndex].countryId,
  //   //   ReportDueDate: this.reportSchedule[reportscheduleIndex].dueDate,
  //   //   IsReleased: false
  //   // });

  //   console.log(
  //     'RECALL DATA ------------------------------' + JSON.stringify(this.reportScheduleData[reportscheduleIndex])
  //   );

  //   // this.reportSchedule.editReportSchedule(this.recallReportScheduleData).subscribe(resp => {
  //   //   if (resp.ok) {
  //   //     this.mapReportSchedule(this.selectedYear.year);
  //   //     this.notifier.notify('success', 'Schedules recalled successfully');
  //   //     console.log(resp);
  //   //   }
  //   // });
  // }

  previewReportSchedule() {
    this.previewReportScheduleDialog = true;
    // this.releaseReportSchedule = [];
    // for (let i = 0; i < this.reportScheduleData.length; i++) {
    //   const isSelected = this.reportScheduleData[i].selected;
    //   if (this.reportScheduleData[i].selected === true && this.reportScheduleData[i].isReleased === false) {
    //     this.releaseReportSchedule.push(this.reportScheduleData[i]);
    //   }
    // }
  }

  closePreviewReportDialog() {
    this.previewReportScheduleDialog = false;
  }

  closeAddNewReportDialog() {
    this.addNewReportDialog = false;
    this.selectedDueDate = false;
  }

  saveNewReport() {
    if(!this.selectedCategory || !this.selectedFrequencyType || !this.selectedCountry || !this.selectedPost || !this.selectedDistribution || !this.selectedDueDate){
      var errorMessage = (this.selectedCategory ? '' : 'Category, ') + 
        (this.selectedFrequencyType ? '' : 'FrequencyType, ') + 
        (this.selectedCountry ? '' : 'Country, ') + 
        (this.selectedPost ? '' : 'Post, ') + 
        (this.selectedDistribution ? '' : 'Distribution, ') + 
        (this.selectedDueDate ? '' : 'Due Date,');
      errorMessage = errorMessage.slice(0,errorMessage.length -1) + ' cannot be empty!';
      this.notifier.notify('error', errorMessage);
      return;
    }
    this.addNewReportDialog = false;
    this.addNewReportfields = [];
    this.selectedDueDate = false;

    for (const reportSchedule of this.addNewReportSchedule) {
      this.addNewReportfields.push({
        Id: reportSchedule.id,
        ProgramAreaId: reportSchedule.ProgramAreaId,
        ReportYear: this.selectedYear.year,
        ReportYearId: this.selectedYear.id,
        CategoryId: reportSchedule.categoryId,
        ReportName: reportSchedule.categoryName + ' ' + reportSchedule.frequencyTypeName,
        IsRequired: true,
        IsPublic: reportSchedule.distribution === 'Public' ? true : false,
        PostLocationId: reportSchedule.fasPostId,
        ParentLocationId: reportSchedule.countryId,
        ReportDueDate: reportSchedule.dueDate,
        ProposedDueDate: reportSchedule.proposedDueDate,
        IsReleased: false,
        FrequencyTypeId: reportSchedule.frequencyTypeId
      });
    }

    this.reportSchedule.createReportSchedule(this.addNewReportfields).subscribe((data: any) => {
      if (data.body)
        this.notifier.notify('error', 'One or more Report Schedules already exists in the system.');
      if (!data.body){
        this.mapReportSchedule(this.selectedYear.year);
        this.notifier.notify('success', 'Report Schedules added successfully');
      }
    });
  }

  addNewReport() {
    this.addNewReportDialog = true;
    this.addNewReportSchedule = [];
    this.onClickAddNewReportSchedule();
    this.lookupService.getFrequencyTypes$().subscribe((data:FrequencyType[]) => {
        this.frequencyTypes = data.sort();
    });
    // this.reportNameData.sort(
    //   (a, b): number => {
    //     if (a.reportName < b.reportName) return -1;
    //     if (a.reportName > b.reportName) return 1;
    //     return 0;
    //   }
    // );
  }

  onClickAddNewReportSchedule() {
    this.selectedCategory = false;
    this.selectedFrequencyType = false;
    this.selectedCountry = false;
    this.selectedPost = false;
    this.selectedDistribution = false;
    this.selectedDueDate = false;
    this.addNewReportSchedule.push({
      id: null,
      reportNumber: null,
      category: null,
      reportName: null,
      fasPost: null,
      country: null,
      programArea: null,
      division: null,
      dueDate: null,
      dueDateInNextYear: null,
      proposedDueDate:null,
      region: null,
      reportType: null,
      fasPostId: null,
      approverId: null,
      highlights: null,
      preparedBy: null,
      distribution: null,
      selected: true,
      categoryName: null,
      isReleased: null,
      categoryId: null,
      reportState: null,
      reportStateId: null,
      isPublic: null,
      isRequired: null,
      isReportLocked:null,
      lastUpdatedDatetime:null
    });
  }

  dueDateInNextYear(dueDate: Date)
 {
      return new Date(dueDate.setFullYear(dueDate.getFullYear() + 1));
 }

  replicateReports() {
    this.replicateReportsfields = [];
    // console.log("Number of records"+ this.replicateReportScheduleData.length);
    // console.log("Number of records"+ JSON.stringify(this.replicateReportScheduleData[0]));

    for (const reportSchedule of this.replicateReportScheduleData) {
      // const isSelected = reportSchedule.selected;
      // if (isSelected) {
      this.replicateReportsfields.push({
        Id: reportSchedule.id,
        ProgramAreaId: this.programArea.id,
        ReportYear: this.selectedYear.year,
        ReportYearId: this.selectedYear.id,
        CategoryId: reportSchedule.categoryId,
        ReportName: reportSchedule.reportName,
        IsRequired: true,
        IsPublic: reportSchedule.distribution === 'Public' ? true : false,
        PostLocationId: reportSchedule.postLocationId,
        ParentLocationId: reportSchedule.parentPostLocationId,
        ReportDueDate: this.dueDateInNextYear(new Date(reportSchedule.reportDueDate)), //this.isReportScheduleEditable ? reportSchedule.dueDateInNextYear : reportSchedule.dueDate,
        IsReleased: false


      });
      // }
    }
    // console.log("Number of records"+ JSON.stringify(this.replicateReportsfields[0]));

    this.reportSchedule.createReportSchedule(this.replicateReportsfields).subscribe(resp => {
      if (resp.ok) {
        this.mapReportSchedule(this.selectedYear.year);
        this.notifier.notify('success', 'Schedules saved successfully');
      }     else
      {
          this.notifier.notify('error', 'Duplicate Schedule');
      }
    });
  }

  deleteReportSchedule(reportscheduleIndex) {
    this.reportScheduleData.splice(reportscheduleIndex, 1);
  }

  deleteFromAddNewReportSchedule(reportscheduleIndex) {
    this.addNewReportSchedule.splice(reportscheduleIndex, 1);
    if(!this.addNewReportSchedule.find(x=>x.categoryId==null)){
      this.selectedCategory = true;
    }
    if(!this.addNewReportSchedule.find(x=>x.frequencyTypeId==null)){
      this.selectedFrequencyType = true;
    }
    if(!this.addNewReportSchedule.find(x=>x.countryId==null)){
      this.selectedCountry = true;
    }
    if(!this.addNewReportSchedule.find(x=>x.fasPostId==null)){
      this.selectedPost = true;
    }
    if(!this.addNewReportSchedule.find(x=>x.dueDate==null)){
      this.selectedDueDate = true;
    }
    if(!this.addNewReportSchedule.find(x=>x.distribution==null)){
      this.selectedDistribution = true;
    }
  }

  deleteFromReleaseReportSchedule(reportscheduleIndex) {
    //console.log("Report Id to DELETE" + this.releaseReportSchedule[reportscheduleIndex].id);
    this.reportSchedule.deleteReportSchedule(this.releaseReportSchedule[reportscheduleIndex].id).subscribe(resp => {
      if (resp.ok) {
        this.notifier.notify('success', 'Schedules deleted successfully');
      }
    });
    this.releaseReportSchedule.splice(reportscheduleIndex, 1);
    this.previewButton = false;
    this.mapReportSchedule(this.selectedYear.year);
  }

  releaseRecallReportToPost() {
    this.editReportsfields = [];
    for (const reportSchedule of this.releaseReportSchedule) {
      this.editReportsfields.push({
        Id: reportSchedule.id,
        ProgramAreaId: this.programArea.id,
        ReportYear: this.selectedYear.year,
        ReportYearId: this.selectedYear.id,
        CategoryId: reportSchedule.categoryId,
        ReportName: reportSchedule.reportName,
        IsRequired: true,
        IsPublic: reportSchedule.distribution === 'Public' ? true : false,
        PostLocationId: reportSchedule.postLocationId,
        ParentLocationId: reportSchedule.parentPostLocationId,
        ReportDueDate: reportSchedule.reportDueDate==null? null: new Date(reportSchedule.reportDueDate),
        ProposedDueDate:reportSchedule.proposedDueDate==null? null: new Date(reportSchedule.proposedDueDate),
        IsReleased: true
      });

    }
    // console.log("ISPUBLIC"+ JSON.stringify(this.editReportsfields[0]));

    this.previewReportSchedule();
    this.closePreviewReportDialog();
    this.reportSchedule.releaseRecallReportSchedule(this.editReportsfields).subscribe((data: any) => {
      if (data.body)
        this.notifier.notify('error', 'One or more Report Schedules already exists in the system.');
      if (!data.body){
        this.releaseReportSchedule =[];
        this.mapReportSchedule(this.selectedYear.year);
        this.notifier.notify('success', 'Report Schedules Released successfully');
      }
    });
  }
}
